export const ProductCardUpdatedSkeleton = () => {
    return (
      <div className="flex w-full min-w-full flex-col gap-[16px] items-start overflow-hidden animate-pulse">
  
        <div className="bg-[#f3f3f4] relative w-full overflow-hidden">
          <div className="w-full h-[248px] bg-gray-200 relative">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
          </div>
  
          <div className="absolute top-3 right-3 w-[40px] h-[40px] rounded-full bg-gray-200 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
          </div>
        </div>
  
        <div className="flex flex-col items-start gap-[8px] w-full">
  
          <div className="h-5 w-3/4 bg-gray-200 rounded relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
          </div>
  
          <div className="flex items-center gap-[8px] w-full">
  
            <div className="flex gap-[4px]">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="w-4 h-4 bg-gray-200 rounded relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
                </div>
              ))}
            </div>
  
            <div className="h-4 w-10 bg-gray-200 rounded relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
            </div>
  
            <div className="h-4 w-16 bg-gray-200 rounded relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
            </div>
          </div>
  
          <div className="h-5 w-20 bg-gray-200 rounded relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer" />
          </div>
        </div>
      </div>
    );
  };
  
  export default ProductCardUpdatedSkeleton;
  